import {z} from '@hono/zod-openapi';

import {composeMessageFactSchema} from './ComposeMessageFactSchema';
import {composeMessageLocaleSchema} from './ComposeMessageLocaleSchema';
import {composeMessageUnavailableFactSchema} from './ComposeMessageUnavailableFactSchema';

export const composeMessageContextSchema = z
  .object({
    locale: composeMessageLocaleSchema,
    languageSource: z.enum(['customer', 'tenant']),
    facts: z.array(composeMessageFactSchema).max(64),
    unavailableFacts: z.array(composeMessageUnavailableFactSchema).max(64),
  })
  .strict()
  .superRefine((context, validation) => {
    const keys = [...context.facts, ...context.unavailableFacts].map((fact) => fact.key);
    if (new Set(keys).size !== keys.length) {
      validation.addIssue({code: z.ZodIssueCode.custom, message: 'Fact keys must be unique'});
    }
  })
  .openapi('ComposeMessageContext');

export type ComposeMessageContext = z.infer<typeof composeMessageContextSchema>;
